export default "__VITE_ASSET__08532edf__"